import EmberObject from '@ember/object';

export function computeFromComponentValues(c1, c2, r1, r2, r3, r4, r5, gbw) {
  var resOne = 1 / (1 / r1 + 1 / r2);
  var resTwo = r5;
  var w0 = 1 / Math.sqrt(resOne * resTwo * c1 * c2);
  var fp = w0 / 2 / Math.PI;
  var q0 = (1 / 2) * Math.sqrt(resTwo / resOne);
  var a = resOne / r1;
  var gain0 = ((1 / 2) * a * resTwo) / resOne;
  var q;
  var gain;
  var k;
  var alpha;

  if (r4 > 1e20) {
    q = q0;
    gain = gain0;
    k = 0;
  } else {
    k = r3 / (r3 + r4);
    alpha = k / (1 - k);
    q = q0 / (1 - 2 * alpha * q0 * q0);
    gain = (gain0 * q) / q0 / (1 - k);
  }

  var epsilon = ((2 * q0) / (gbw / fp)) * (1 / ((1 - k) * (1 - k)));
  var errorplusOne = Math.sqrt(1 + epsilon);
  fp = fp / errorplusOne;
  q = q / errorplusOne;

  var result = EmberObject.create({ stageQ: q, stageFp: fp, gain: gain });
  return result;
}

export function execute(circuit) {
  var r1 = circuit.r1.value;
  var r2 = circuit.r2.value;
  var r3 = circuit.r3 ? circuit.r3.value : null;
  var r4 = circuit.r4 ? circuit.r4.value : null;
  var r5 = circuit.r5.value;
  var c1 = circuit.c1.value;
  var c2 = circuit.c2.value;
  var gbw = circuit.opAmp.gbw;
  return this.computeFromComponentValues(c1, c2, r1, r2, r3, r4, r5, gbw);
}
